import React from 'react';
import { MaterialsFilterPanel } from './MaterialsFilterPanel';
import { MaterialsTagsPanel } from './MaterialsTagsPanel';
interface MaterialsCatalogPanelProps {
  cabinetMaterialSearch: string;
  setCabinetMaterialSearch: (search: string) => void;
  showOnlyCabinetFavorites: boolean;
  setShowOnlyCabinetFavorites: (show: boolean) => void;
  showOnlySelectedMaterials: boolean;
  setShowOnlySelectedMaterials: (show: boolean) => void;
  cabinetMaterials: any[];
}
export function MaterialsCatalogPanel({
  cabinetMaterialSearch,
  setCabinetMaterialSearch,
  showOnlyCabinetFavorites,
  setShowOnlyCabinetFavorites,
  showOnlySelectedMaterials,
  setShowOnlySelectedMaterials,
  cabinetMaterials
}: MaterialsCatalogPanelProps) {
  return <div className="flex-1 overflow-y-auto p-4" data-id="element-821">
      <MaterialsFilterPanel cabinetMaterialSearch={cabinetMaterialSearch} setCabinetMaterialSearch={setCabinetMaterialSearch} showOnlyCabinetFavorites={showOnlyCabinetFavorites} setShowOnlyCabinetFavorites={setShowOnlyCabinetFavorites} showOnlySelectedMaterials={showOnlySelectedMaterials} setShowOnlySelectedMaterials={setShowOnlySelectedMaterials} data-id="element-822" />
      <div className="flex gap-4" data-id="element-823">
        {/* Materials grid - now consistently 2 columns */}
        <div className="grid grid-cols-2 gap-3 flex-1" data-id="element-824">
          {cabinetMaterials.map(material => {
          // Determine material color display
          let materialColor = material.color || '#e5e7eb';
          let colorStyle = {};
          if (material.color) {
            if (material.color.startsWith('bg-')) {
              // Use Tailwind class
              colorStyle = {}; // No inline style needed
            } else {
              // Use direct color value
              colorStyle = {
                backgroundColor: materialColor
              };
            }
          } else if (material.category === 'Wood') {
            colorStyle = {
              backgroundColor: '#A47551'
            };
          } else if (material.category === 'Glass') {
            colorStyle = {
              backgroundColor: '#D7E9F7'
            };
          } else if (material.category === 'Stone') {
            colorStyle = {
              backgroundColor: '#C2C2C2'
            };
          } else if (material.category === 'Metal') {
            colorStyle = {
              backgroundColor: '#B8B8B8'
            };
          } else if (material.category === 'Fabric') {
            colorStyle = {
              backgroundColor: '#E3D9C6'
            };
          } else if (material.category === 'Plastic') {
            colorStyle = {
              backgroundColor: '#D0D0D0'
            };
          } else if (material.category === 'Tile') {
            colorStyle = {
              backgroundColor: '#E8E8E8'
            };
          }
          return <div key={material.id} className="relative group border border-gray-200 rounded-lg overflow-hidden bg-white dark:bg-darkbg-secondary dark:border-darkbg-border cursor-pointer hover:shadow-sm" data-id="element-825">
                <div className="flex justify-center items-center p-3 h-24" data-id="element-826">
                  {/* Enhanced color display with better visual feedback */}
                  <div className="w-16 h-16 rounded-full shadow-sm" style={colorStyle} data-id="element-827">
                    {material.color && material.color.startsWith('bg-') && <div className={`w-full h-full rounded-full ${material.color}`} data-id="element-828"></div>}
                  </div>
                </div>
                <div className="px-3 pb-3 text-center" data-id="element-829">
                  <p className="text-xs font-medium text-gray-800 dark:text-gray-200 truncate" data-id="element-830">
                    {material.name}
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-831">
                    {material.category}
                  </p>
                </div>
              </div>;
        })}
        </div>
        <MaterialsTagsPanel data-id="element-832" />
      </div>
      {/* Show message if no materials match the filter */}
      {cabinetMaterials.length === 0 && <div className="text-center py-8" data-id="element-833">
          <p className="text-base text-gray-500 dark:text-gray-400" data-id="element-834">
            No materials match the current filters.
          </p>
          <button className="mt-3 text-sm text-blue-600 hover:text-blue-800 dark:text-accent-blue dark:hover:text-blue-400" onClick={() => {
        setCabinetMaterialSearch('');
        setShowOnlyCabinetFavorites(false);
        setShowOnlySelectedMaterials(false);
      }} data-id="element-835">
            Clear filters
          </button>
        </div>}
    </div>;
}